import validEmail from './validEmail';
import validPassword from './validPassword';
import fieldStatus from './fieldStatus';
import highlightLabel from './highlightLabel';

let grecaptcha = window.grecaptcha || {};

export default (field) => {
  const form = field.closest('form');
  const error_message = 'error';

  switch (field.type) {
    case 'email': {
      if (!validEmail(field.value)) {
        field.classList.add('input-error');
        highlightLabel(field);
        return fieldStatus(false, error_message);
      }
      break;
    }
    case 'password': {
      if (!validPassword(field.value)) {
        field.classList.add('input-error');
        highlightLabel(field);
        return fieldStatus(false, error_message);
      }
      const passwords = form.querySelectorAll('input[type="password"]');
      if (passwords.length > 1) {
        if (passwords[0].value !== passwords[1].value) {
          passwords.forEach((p) => p.classList.add('input-error'));
          return fieldStatus(false, error_message);
        }
      }
      break;
    }
    case 'text': {
      if (!field.value || field.value.trim() === '') {
        field.classList.add('input-error');
        highlightLabel(field);
        return fieldStatus(false, error_message);
      }
      break;
    }
    case 'captcha': {
      if (!grecaptcha.getResponse()) {
        field.classList.add('input-error');
        highlightLabel(field);
        return fieldStatus(false, error_message);
      }
      break;
    }
    case 'media-channels': {
      if (field.querySelectorAll('.revealed').length === 0) {
        field.classList.add('input-error');
        highlightLabel(field);
        return fieldStatus(false, error_message);
      }
      break;
    }
    case 'checkbox': {
      if (!field.checked) {
        field.classList.add('input-error');
        highlightLabel(field);
        return fieldStatus(false, error_message);
      }
      break;
    }
    default: {
      if (!field.value || field.value.trim() === '') {
        field.classList.add('input-error');
        highlightLabel(field);
        return fieldStatus(false, error_message);
      }
      break;
    }
  }

  field.classList.remove('input-error');
  const label = field.closest('.Form__input-item')?.querySelector('.Form__label');
  if (label) label.classList.remove('Form__label--error');

  field.querySelectorAll('.Form__label').forEach((label) => label.classList.remove('Form__label--error'));

  if (field.type === 'password' && form.querySelectorAll('input[type="password"]').length > 1) {
    form.querySelectorAll('input[type="password"]').forEach((p) => p.classList.remove('input-error'));
  }

  return fieldStatus(true, '');
};
